import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { ErDisbursmentReceipt } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  erDisbursments: ErDisbursmentReceipt[];
}

const TableRow = ({ erDisbursment }: { erDisbursment: ErDisbursmentReceipt }) => (
  <Table.Row>
    <Table.Cell>{erDisbursment.phn}</Table.Cell>
    <Table.Cell>{erDisbursment.streetName}</Table.Cell>
    <Table.Cell>{erDisbursment.fileNumber}</Table.Cell>
    <Table.Cell>{erDisbursment.buildingBalanceAmount}</Table.Cell>
    <Table.Cell>{erDisbursment.boroughCode}</Table.Cell>
  </Table.Row>
);

const ErDisbursmentTab = (props: PropTypes) => {
  const [sortedErDisbursements, setSortedErDisbursements] = useState<ErDisbursmentReceipt[]>([]);
  useEffect(() => {
    if (props.erDisbursments) {
      setSortedErDisbursements(props.erDisbursments);
    }
  }, [props.erDisbursments]);
  return (
    <React.Fragment>
      {sortedErDisbursements.length === 0 ? (
        <div>No records available</div>
      ) : (
        <Table striped columns={5} sortable>
          <TableHeader
            columnNames={[
              'Primary House Number',
              'Street Name',
              'File Number',
              'Building Balance Amount',
              'Borough Code',
            ]}
            sortedData={sortedErDisbursements}
            setSortedData={setSortedErDisbursements}
          />
          <Table.Body>
            {sortedErDisbursements.map(er => (
              <TableRow erDisbursment={er} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default ErDisbursmentTab;
